import forgot from './forgot';
import verify from './verify';

const recoverRoutes = [
    forgot,
    verify,
];

export default recoverRoutes;